import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const uiAnalyticsEvents = createAsyncThunk(
  "uiAnalytics/uiAnalyticsEvents",
  async (payload, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams(window.location.search);

      if (queryParams.has("spo")) {
        console.warn("Caller token is null for this payload", payload);
        return null;
      }

      // Skip when there is no caller token — the backend rejects a blank
      // callerToken with a 400 (@NotBlank), so firing the request is pointless.
      if (!payload?.callerToken || !payload.callerToken.trim()) {
        console.warn("UI analytics skipped: missing callerToken", payload);
        return null;
      }

      if (payload?.callerToken?.includes("st_")) {
        return null;
      }

      const payloadWithBrowserData = {
        ...payload,
        browserData: {
          userAgentHeader: navigator.userAgent,
          browserLanguage: navigator.language,
        },
      };

      const response = await axios.post(
        `${baseUrl}/ui-analytics`,
        payloadWithBrowserData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const initialState = {
  uiEventData: null,
  uiEventLoading: false,
  uiEventErrorMessage: "",
};

export const uiAnalyticsEventSlice = createSlice({
  name: "uiAnalytics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uiAnalyticsEvents.pending, (state) => {
        state.uiEventLoading = true;
        state.uiEventErrorMessage = "";
      })
      .addCase(uiAnalyticsEvents.fulfilled, (state, action) => {
        state.uiEventLoading = false;
        state.uiEventData = action.payload;
      })
      .addCase(uiAnalyticsEvents.rejected, (state, action) => {
        state.uiEventLoading = false;
        state.uiEventErrorMessage = action.payload;
      });
  },
});

export default uiAnalyticsEventSlice.reducer;
